import { render, staticRenderFns } from "./YourHsa.vue?vue&type=template&id=4207f38b&scoped=true"
import script from "./YourHsa.vue?vue&type=script&lang=ts"
export * from "./YourHsa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4207f38b",
  null
  
)

export default component.exports